// removed by extract-text-webpack-plugin
module.exports = {"root":"root__XwqXj","logo":"logo__2wWKE","links":"links__z5fNV","shareLink":"shareLink__1qm6Q"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/style.css
// module id = A8Bg
// module chunks = 0